package com.eladfinish.bible.contest.screens.pairMatching.ui.dialogs

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.instruction_pair
import com.eladfinish.bible.contest.screens.pairMatching.PairMatchingAction
import com.eladfinish.bible.contest.screens.pairMatching.PairMatchingState
import com.eladfinish.bible.contest.screens.pairMatching.model.PairsTopic
import com.eladfinish.bible.contest.ui.components.dialogs.AlternateRowColorsDialog
import com.eladfinish.bible.contest.ui.components.dialogs.BasicDialogWithTitle
import com.eladfinish.bible.contest.ui.models.AlternateRowData
import dev.icerock.moko.resources.compose.stringResource
import kotlinx.collections.immutable.toImmutableList

@Composable
fun PairMatchingDialogs(
    dialogState: PairMatchingState.DialogState,
    onAction: (PairMatchingAction) -> Unit,
    onItemClicked: (Int, PairsTopic) -> Unit,
    onConfirmCopyAll: () -> Unit,
    onConfirmCopyOnlyMissing: () -> Unit,
) {
    when (dialogState) {
        is PairMatchingState.DialogState.TableOfContents -> {
            BasicDialogWithTitle(
                onDismiss = {
                    onAction(PairMatchingAction.HideDialog)
                },
                title = stringResource(SharedRes.strings.instruction_pair),
                content = {
                    AlternateRowColorsDialog(
                        items = dialogState.items.map {
                            AlternateRowData(
                                title = it.topic,
                                subtitle = it.source,
                            )
                        }.toImmutableList(),
                        itemAsString = { it.title },
                        onItemClick = { index, _ ->
                            onAction(PairMatchingAction.HideDialog)
                            onItemClicked(index, dialogState.items[index])
                        },
                    )
                }
            )
        }

        PairMatchingState.DialogState.CopyPairs -> {
            CopyPairsDialog(
                onDismiss = {
                    onAction(PairMatchingAction.HideDialog)
                },
                onConfirmCopyAll = onConfirmCopyAll,
                onConfirmCopyOnlyMissing = onConfirmCopyOnlyMissing,
            )
        }

        PairMatchingState.DialogState.None -> Unit
    }
}
